



























import Vue from 'vue'
import SizeInput from '@/common/components/SizeInput.vue'
import { SkuSize } from '@/product/types'

export default Vue.extend({
  components: { SizeInput },
  props: {
    size: {
      type: Object as () => SkuSize,
      required: true
    }
  },
  computed: {
    inputVal: {
      get(): number {
        return this.size.quantity
      },
      set(value: number) {
        this.$emit('change', value)
      }
    },
    disabled(): boolean {
      return !this.size.hasStock
    }
  }
})
